<template>
  <div class="menu-item" :class="{ active: currentab === titleID && showActive }" @click="openmenuitem(title)">
    <span class="menu-item-icon">
      <img :src="imgUrl(icon)" :alt="title">
    </span>
    <div class="menu-item-title">
      {{ title === 'Remote' ? 'Remote access' : title }}
      <span class="menu-item-arrow">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 8H14M14 8L6.92857 1M14 8L6.92857 15" stroke="#9485EF" stroke-width="2"/>
        </svg>
      </span>
    </div>
    <p class="menu-item-text" v-if="showtext === 'wide'">{{ text }}</p>
  </div>
</template>

<script>
const images = require.context('../assets/img/menus/', false, /\.svg$/)
export default {
  name: 'Menu',
  props: ['titleID', 'title', 'text', 'icon', 'currentab', 'showtext', 'showActive'],
  methods: {
    imgUrl: function (path) {
      return images('./' + path)
    },
    openmenuitem (title) {
      this.$emit('openmenuitem', title);
    }
  }
}
</script>

<style lang="scss">
@import "../assets/styles/helpers";

.menu-item {
  background: #EFF0F7;
  border-radius: 20px;
  padding: 24px;
  position: relative;
  width: calc(50% - 30px);
  margin: 15px;
  cursor: pointer;
  transition: padding .3s;

  &.active {
    background: white;

    .menu-item-arrow {
      display: flex;
    }
  }

  &-title {
    font-size: 24px;
    font-weight: 800;
    color: #27272C;
    margin-bottom: 24px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &-text {
    max-width: 70%;
  }

  &-arrow {
    display: none;
  }

  &-icon {
    position: absolute;
    right: 5px;
    bottom: 10px;
    width: 30%;

    &:before {
      content: "";
      display: block;
      width: 64px;
      height: 64px;
      border-radius: 50%;
      background: #FFD02A;
      position: absolute;
      left: 0;
      bottom: 0;
      transform: translateY(30%);
    }

    img {
      max-width: 100%;
      width: 65px;
      position: relative;
    }
  }
}

.wide {
  flex: 1 1 50%;
  min-width: 50%;

  @include responsive-above('1600px'){
    flex: 1 1 40%;
    min-width: 40%;
  }

  .logo {
    max-width: 45%;
  }

  &.dashboard {
    background: #F5F7FB;
    position: relative;

    .btn-switch-mode {
      position: absolute;
      top: 40px;
      right: 35px;
    }

    .header {
      padding-top: 40px;
    }
  }

  .menu-item {
    background: #E0E1EF;
    padding-top: 5%;
    padding-bottom: 5%;
    overflow: hidden;

    @include responsive-below-height('800px'){
      padding-top: 25px;
      padding-bottom: 25px;
      margin-top: 10px;
      margin-bottom: 10px;

      &-title {
        margin-bottom: 10px;
      }
    }

    @include responsive-below-height('700px'){
      padding-top: 15px;
      padding-bottom: 15px;
    }

    &.transparent {
      background: transparent;
    }

    &:not(.transparent):hover {
      background: #fff;
    }
  }

  .menu-item-arrow {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #CFD0E4;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    
    svg path {
      stroke: #27272C;
    }
  }
}

.narrow {
  flex: 0 0 314px;

  @include responsive-below($lg){
    flex-basis: 260px;
  }

  .btn-switch-mode {
    width: 100%;

    @include responsive-below($lg){
      padding: 12px 15px;
    }
  }

  .dashboard {
    &-title {
      font-size: 20px;
    }

    &-subtitle {
      font-size: 14px;
    }

    &-menu {
      border-right: 1px solid #EFF0F7;
      padding: 0;

      @include responsive-below($sm){
        padding: 5px 24px;
      }
    }
  }

  .switch-mode-block {
    padding-left: 40px;

    @include responsive-below($lg){
      padding-left: 24px;
    }
  }

  .menu-item {
    margin: 0;
    padding: 34px 40px;
    width: 100%;
    border-radius: 0;

    @include responsive-below-height('850px'){
      padding: 25px 40px;
    }

    @include responsive-below-height('750px'){
      padding: 18px 40px;
    }

    @include responsive-below($lg){
      padding: 24px;
    }

    @include responsive-below($sm){
      background: #E0E1EF;
      border-radius: 8px;
      margin-bottom: 10px;
    }

    @include responsive-below($xs){
      padding: 15px 24px;
    }

    &:not(.transparent) {
      display: flex;
      align-items: center;
    }

    &.transparent {
      background: #F5F7FB;

      @include responsive-below($xs){
        padding: 0;
      }
    }

    &-title {
      margin-bottom: 0;
      font-size: 18px;
    }

    &-icon {
      position: relative;
      width: 35px;
      right: 0;
      bottom: 0;
      margin-right: 20px;

      &:before {
        width: 30px;
        height: 30px;
        transform: none;
      }
    }
  }
}
</style>
